import { captureException } from '@sentry/react'
import { type UseQueryOptions, useQuery } from '@tanstack/react-query'
import {
	type HttpGetPhotosetSpacesOptions,
	HttpGetPhotosetSpacesResponse,
	httpGetPhotosetSpaces
} from '@/features/photoset/http/photoset.http'
import { parseAxiosPromise } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useGetPhotosetSpaces = (
	promiseArgs: HttpGetPhotosetSpacesOptions,
	options?: Omit<
		UseQueryOptions<HttpGetPhotosetSpacesResponse>,
		'queryFn' | 'queryKey'
	>
) =>
	useQuery({
		...options,
		queryKey: [QUERY_KEYS.PHOTOSET_SPACES, promiseArgs],
		queryFn: () =>
			parseAxiosPromise({
				axiosPromise: httpGetPhotosetSpaces(promiseArgs),
				responseShape: HttpGetPhotosetSpacesResponse,
				onZodError: captureException
			})
	})
